/**
 * Shared session display title — same rules as facilitator report/session lists (activity · team, else session name, else id).
 */

export interface SessionTitleParts {
  activityTitle?: string | null
  sessionName?: string | null
  teamName?: string | null
  fallback: string
}

export function buildSessionDisplayTitle({
  activityTitle,
  sessionName,
  teamName,
  fallback
}: SessionTitleParts): string {
  const trimmedActivity = activityTitle?.trim()
  const trimmedTeam = teamName?.trim()
  const parts = [trimmedActivity, trimmedTeam].filter(Boolean) as string[]

  if (parts.length > 0) {
    return parts.join(' · ')
  }

  const trimmedSessionName = sessionName?.trim()
  if (trimmedSessionName) {
    return trimmedSessionName
  }

  return fallback
}
